import MarketInactiveIcon from '../../asset/svg/bottom-navigation/market-active0-push0.svg';
import MarketActiveIcon from '../../asset/svg/bottom-navigation/market-active1-push0.svg';
import MypageInactiveIcon from '../../asset/svg/bottom-navigation/mypage-active0-push0.svg';
import MypageActiveIcon from '../../asset/svg/bottom-navigation/mypage-active1-push0.svg';
import RecipeInactiveIcon from '../../asset/svg/bottom-navigation/recipe-active0-push0.svg';
import RecipeInactiveNotifiactionIcon from '../../asset/svg/bottom-navigation/recipe-active0-push1.svg';
import RecipeActiveIcon from '../../asset/svg/bottom-navigation/recipe-active1-push0.svg';
import RecipeActiveNotifiactionIcon from '../../asset/svg/bottom-navigation/recipe-active1-push1.svg';
import RefrigeratorInactiveIcon from '../../asset/svg/bottom-navigation/refrigerator-active0-push0.svg';
import RefrigeratorInactiveNotifiactionIcon from '../../asset/svg/bottom-navigation/refrigerator-active0-push1.svg';
import RefrigeratorActiveIcon from '../../asset/svg/bottom-navigation/refrigerator-active1-push0.svg';
import SubscriptionActiveIcon from '../../asset/svg/bottom-navigation/subscription-active.svg';
import SubscriptionInactiveIcon from '../../asset/svg/bottom-navigation/subscription-inactive.svg';
import { subscriptionMainPageRegex } from '../../constants/regex';
import { useMySubscriptionsQuery } from '../../utils/hook/react-query/useMySubscriptionsQuery';
import { usePathnameMethod } from '../../utils/hook/usePathnameMethod';

export type BottomNavPath =
  | '/main'
  | '/ustore'
  | '/refrigerator'
  | '/recipes'
  | '/mypages';

interface BottomNavIconProps {
  path: BottomNavPath;
  isNotificationOn?: boolean;
}

const BottomNavIcon = ({ path, isNotificationOn }: BottomNavIconProps) => {
  const { pathnameIncludes, pathname } = usePathnameMethod();
  const { hasSubscriptions } = useMySubscriptionsQuery();

  /** 정기배송 메인 페이지 여부 (/subscriptions/{id}/main) */
  const isSubscriptionMainIcon = subscriptionMainPageRegex.test(path);

  const getMainIconActiveState = () => {
    const isMainPage = pathnameIncludes('/main');
    const isSubscriptionMainPage = subscriptionMainPageRegex.test(pathname);

    // Active 조건: 정기배송 메인 화면 OR (일반 메인 & 현재 구독 없음)
    const isActive =
      isSubscriptionMainPage || (isMainPage && !hasSubscriptions);

    return isActive ? SubscriptionActiveIcon.src : SubscriptionInactiveIcon.src;
  };

  const iconMap: Record<BottomNavPath, { src: string; alt: string }> = {
    '/main': {
      src: getMainIconActiveState(),
      alt: '정기배송',
    },
    '/ustore': {
      src: pathnameIncludes('/ustore')
        ? MarketActiveIcon.src
        : MarketInactiveIcon.src,
      alt: '마켓',
    },
    '/refrigerator': {
      src: pathnameIncludes('/refrigerator')
        ? RefrigeratorActiveIcon.src
        : isNotificationOn
          ? RefrigeratorInactiveNotifiactionIcon.src
          : RefrigeratorInactiveIcon.src,
      alt: '마이냉장고',
    },
    '/recipes': {
      src: pathnameIncludes('/recipes')
        ? isNotificationOn
          ? RecipeActiveNotifiactionIcon.src
          : RecipeActiveIcon.src
        : isNotificationOn
          ? RecipeInactiveNotifiactionIcon.src
          : RecipeInactiveIcon.src,
      alt: '오늘 뭐 먹지',
    },
    '/mypages': {
      src: pathnameIncludes('/mypages')
        ? MypageActiveIcon.src
        : MypageInactiveIcon.src,
      alt: '마이페이지',
    },
  };

  const { src, alt } = iconMap[isSubscriptionMainIcon ? '/main' : path];

  return <img src={src} alt={alt} />;
};

export default BottomNavIcon;
